<h2 mat-dialog-title class="dialog-title">
  {{ 'firmwareManagement.updateDialog.title' | translate }}
</h2>

<mat-dialog-content class="dialog-content">
  <!-- Form State -->
  @if (showForm) {
    <div class="device-info">
      <h3 class="section-title">{{ 'firmwareManagement.updateDialog.deviceInfo' | translate }}</h3>
      <div class="info-row">
        <span class="label">{{ 'firmwareManagement.table.deviceLDN' | translate }}:</span>
        <span class="value">{{ device.deviceLDN }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'firmwareManagement.table.installer' | translate }}:</span>
        <span class="value">{{ device.customerName }}</span>
      </div>
      <div class="info-row">
        <span class="label"
          >{{ 'firmwareManagement.updateDialog.currentVersion' | translate }}:</span
        >
        <span class="value">{{ currentVersion || '-' }}</span>
      </div>
    </div>

    <div class="firmware-selection">
      <h3 class="section-title">
        {{ 'firmwareManagement.updateDialog.selectVersion' | translate }}
      </h3>

      @if (installedNotInCatalogue) {
        <xemex-info-banner>
          {{ 'firmwareManagement.updateDialog.notInCatalogue' | translate }}
        </xemex-info-banner>
      }

      <form [formGroup]="form">
        <mat-form-field class="full-width xemex-select" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'firmwareManagement.updateDialog.firmwareVersion' | translate }}</mat-label>
          <mat-select formControlName="firmwareId" required>
            @for (firmware of availableFirmwares; track firmware.firmwareId) {
              <mat-option [value]="firmware.firmwareId">
                {{ firmware.version }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>

      @if (isDlms) {
        <xemex-info-banner>
          {{ 'firmwareManagement.updateDialog.dlmsDuration' | translate }}
        </xemex-info-banner>
      }
    </div>
  }

  <!-- DLMS: no streaming channel, so the dialog confirms the accepted request and stops. -->
  @if (showSubmitted) {
    <div class="submitted-message">
      <mat-icon class="submitted-icon">schedule_send</mat-icon>
      <p class="submitted-title">{{ 'firmwareManagement.updateDialog.submitted' | translate }}</p>
      <p class="submitted-hint">
        {{ 'firmwareManagement.updateDialog.submittedHint' | translate }}
      </p>
    </div>
  }

  <!-- Update Progress State -->
  @if (showStarting || showInProgress || showSuccess || showError) {
    <div class="update-progress">
      <!-- Stage 1: Starting -->
      <div
        class="stage"
        [class.completed]="showInProgress || showSuccess"
        [class.active]="showStarting"
        [class.error]="showError && showInProgress"
      >
        <div class="stage-indicator">
          @if (showInProgress || showSuccess) {
            <mat-icon class="stage-icon completed">check_circle</mat-icon>
          } @else if (showStarting) {
            <xemex-spinner></xemex-spinner>
          } @else {
            <mat-icon class="stage-icon">radio_button_unchecked</mat-icon>
          }
        </div>
        <div class="stage-content">
          <span class="stage-label">{{
            'firmwareManagement.updateDialog.stages.starting' | translate
          }}</span>
        </div>
      </div>

      <div class="stage-connector" [class.completed]="showInProgress || showSuccess"></div>

      <!-- Stage 2: In Progress -->
      <div
        class="stage"
        [class.completed]="showSuccess"
        [class.active]="showInProgress"
        [class.error]="showError"
      >
        <div class="stage-indicator">
          @if (showSuccess) {
            <mat-icon class="stage-icon completed">check_circle</mat-icon>
          } @else if (showInProgress) {
            <xemex-spinner></xemex-spinner>
          } @else if (showError) {
            <mat-icon class="stage-icon error">error</mat-icon>
          } @else {
            <mat-icon class="stage-icon">radio_button_unchecked</mat-icon>
          }
        </div>
        <div class="stage-content">
          <span class="stage-label">{{
            'firmwareManagement.updateDialog.stages.inProgress' | translate
          }}</span>
          @if (showInProgress) {
            <span class="stage-status">{{ statusMessage | translate }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Final Status Messages -->
    @if (showSuccess) {
      <p class="final-message success">{{ statusMessage | translate }}</p>
    }
    @if (showError) {
      <p class="final-message error">{{ statusMessage | translate }}</p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  @if (showForm) {
    <button mat-button (click)="onCancel()" class="cancel-btn">
      {{ 'general.btnCancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onUpdate()"
      [disabled]="!form.valid"
      class="update-btn"
    >
      {{ 'firmwareManagement.updateDialog.updateButton' | translate }}
    </button>
  }

  @if (showStarting || showInProgress) {
    <div class="loading-spacer"></div>
  }

  @if (showSuccess || showError || showSubmitted) {
    <button mat-raised-button color="primary" (click)="onClose()" class="close-btn">
      {{ 'general.btnClose' | translate }}
    </button>
  }
</mat-dialog-actions>
